import { Component,OnInit } from '@angular/core';

import { Platform, ToastController } from '@ionic/angular';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { BackgroundMode } from '@ionic-native/background-mode/ngx';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import {Network} from '@ionic-native/network/ngx';
import { WifiService } from './services/wifi.service';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { SeedsService } from './services/seeds.service';
import swal from 'sweetalert';
import PouchDB from 'pouchdb';
import { SplashScreen } from "@ionic-native/splash-screen/ngx";


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  uid
  appid={
    APP_ID:'bb79d2c2-39e9-4b35-b3ef-43a401a63dba',
    ID:'251862337329'
  }
  isOnline: boolean;

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private back:BackgroundMode,
    private oneSignal:OneSignal,
    private authFire:AngularFireAuth,
    private db:AngularFirestore,
    private auth:AuthService,
    private net:WifiService,
    public seedService:SeedsService,
    public toast:ToastController,
    private splashScreen: SplashScreen,
    private route:Router,

  ) {
    
    this.initializeApp();


    this.net.isOnline().subscribe((online) => {
      this.isOnline = online;
       if(!this.isOnline){
         swal('Error','No hay conexion de Internet','warning')
       }else{
        this.setupPush()
        this.auth.estadoPagos()
        this.seedService.verificarSemillasDanadas()

       }
    });
  
  }
  ngOnInit() {
    
  }

 

  initializeApp() {
    this.platform.ready().then(() => {
      this.splashScreen.hide();
    });

  }
  
  async setupPush() {
    // I recommend to put these into your environment.ts
    var iosSettings = {};
    iosSettings["kOSSettingsKeyAutoPrompt"] = false;
    iosSettings["kOSSettingsKeyInAppLaunchURL"] = false;
    
    this.oneSignal.startInit(this.appid.APP_ID,this.appid.ID);
    this.oneSignal.promptForPushNotificationsWithUserResponse();
    this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);
    this.oneSignal.setSubscription(true);
    
  
    this.oneSignal.getIds().then(g=>{
      console.log(g.pushToken)

    this.authFire.auth.onAuthStateChanged(f=>{
    
      this.uid=f.uid
      this.db.collection('usuarios').doc(f.uid).update({
           oneSigID:g.userId,
           tokenSigID:g.pushToken
      })
    })
     
  })
  
 
    this.oneSignal.endInit();
  }

 
}
